<template>
    <div class="notifyLog-big">
        <div class="notifyLog" v-loading="loading">
            <div class="notifyLog-box" v-for="(item,index) in notifyLogList" :key="index">
                <!-- <p>{{JSON.parse(item.snap).content}}</p> -->
                <div class="notifyLog-box-content">{{item.content}}</div>
                <div class="notifyLog-box-time">{{item.created_at}}</div>
            </div>
            <noData v-if="noData && !loading"></noData>
            <p class="p" v-if="noMore && !noData">已经到底了~</p>
        </div>
    </div>
</template>
<script>
    import noData from '@/components/noData/index.vue'
    import request from "@/utils/request";
    export default {
        components: {noData},
        data() {
            return {
                notifyLogList:[],
                query:{
                    page:1,
                    limit:10,
                },
                noData:false,
                noMore:false,
                loading:true,
            }
        },
        created(){
            this.notifyLog()
        },
        mounted () {
            window.addEventListener('scroll', this.handleScroll1);  // 监听（绑定）滚轮滚动事件
        },
        destroyed () {
            window.removeEventListener('scroll', this.handleScroll1);   //  离开页面清除（移除）滚轮滚动事件
        },
        methods:{
            handleScroll1() {
                var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
                //变量windowHeight是可视区的高度
                var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
                //变量scrollHeight是滚动条的总高度
                var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
                //滚动条到底部的条件
                if(scrollTop+windowHeight==scrollHeight){
                    if(!this.noMore){
                        console.log('触底')
                        this.query.limit += 10
                        this.notifyLog()
                    }
                    //写后台加载数据的函数
                    // console.log("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight);
                }          
            },
            notifyLog(){
                this.loading=true
                return request({
                    url: '/api/userend/user/notifyLog',
                    method: 'get',
                    params: this.query
                }).then(response =>{
                    this.notifyLogList=response.data.data
                    this.loading=false
                    if(this.notifyLogList.length < this.query.limit){
                        this.noMore=true
                    }
                    this.noData=response.data.data.length==0;
                    this.$parent.info()
                })
            },
        }
    }
</script>
<style lang="scss">
.notifyLog-big{
    .el-loading-spinner{
        position: fixed;
        top: 400px;
        right: 220px;
    }
    .notifyLog{
        padding: 0 30px;
        .p{
            text-align: center;
            padding: 5px 0 15px 15px;
        }
       .notifyLog-box{
           padding: 20px 0;
           border-bottom: 1px solid #F9FAFD;
           p{
            font-size: 22px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #1E2134;
           }
           .notifyLog-box-content{
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 30px;
           }
           .notifyLog-box-time{
               margin-top: 15px;
               text-align: right;
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #858585;
           }
       } 
    }
}
</style>